import { useEffect, useState } from "react";
import {
  AppBar,
  Box,
  Button,
  Container,
  Toolbar,
  Typography,
  Avatar,
  Chip,
  Stack,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { fetchMe, clearIapSession, LOGGED_OUT_FLAG } from "../api/billingApi";

export function Layout({ children }: { children: React.ReactNode }) {
  const [userEmail, setUserEmail] = useState<string | null>(null);

  useEffect(() => {
    fetchMe().then((me) => setUserEmail(me?.email ?? null));
  }, []);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <AppBar position="static" color="default" elevation={1}>
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1, fontWeight: 600 }}>
            LEIAA Billing Admin
          </Typography>
          <Stack direction="row" spacing={1.5} alignItems="center">
            {userEmail && (
              <Chip
                avatar={<Avatar>{userEmail.charAt(0).toUpperCase()}</Avatar>}
                label={userEmail}
                variant="outlined"
              />
            )}
            <Button
              size="small"
              color="inherit"
              startIcon={<LogoutIcon />}
              onClick={async () => {
                await clearIapSession();
                sessionStorage.setItem(LOGGED_OUT_FLAG, "1");
                window.location.assign("/");
              }}
            >
              Logout
            </Button>
          </Stack>
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg" sx={{ py: 4, flexGrow: 1 }}>
        {children}
      </Container>
    </Box>
  );
}
